import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';

function ExecutedCell(props) {
  const { dataItem, field } = props;
  const value = dataItem[field];
  const icon = value ? faCheck : faMinus;

  return (
    <td className="icon-cell executed-status">
      {icon && <FontAwesomeIcon icon={icon} />}
    </td>
  );
}

ExecutedCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
}

export default ExecutedCell;
